import * as THREE from "three";
import * as ZapparThree from "@zappar/zappar-threejs";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

let mixer: any;
let clock = new THREE.Clock();
let idleAction: THREE.AnimationAction;
let danceLoopAction: THREE.AnimationAction;
let laughAction: THREE.AnimationAction;
let roarAction: THREE.AnimationAction;

let onScreenElmoGroup: THREE.Group;
let faceTrackerGroup: ZapparThree.FaceAnchorGroup;

let elmo: any;
let currentAction: THREE.AnimationAction;

const elmoModelSrc = new URL("../assets/models/Elmo_Dino_Stomp.glb", import.meta.url).href;

export function initElmo(faceAnchorGroup: any, manager: any, scene: THREE.Scene) {
  faceTrackerGroup = faceAnchorGroup;
  //ELMO
  new GLTFLoader().load(
    elmoModelSrc,
    function (gltf) {
      elmo = gltf.scene;
      elmo.scale.set(6.3, 6.3, 6.3);
      elmo.position.set(1, -1.68, 0.02);
      faceTrackerGroup.add(gltf.scene);

      elmo.traverse(function (node: any) {
        if (node.isMesh) {
          node.recieveShadow = true;
          node.castShadow = true;
        }
      });

      const animations = gltf.animations;
      mixer = new THREE.AnimationMixer(gltf.scene);
      mixer.timeScale = 1;
      idleAction = mixer.clipAction(animations[0]);
      danceLoopAction = mixer.clipAction(animations[2]);
      laughAction = mixer.clipAction(animations[5]);
      roarAction = mixer.clipAction(animations[4]);
      resetDanceLoop();

      mixer.addEventListener("loop", onLoopFinished);
      function onLoopFinished(event: any) {
        if (danceLoopAction.getEffectiveWeight() === 0) {
          executeCrossFade(currentAction, danceLoopAction, 0.5);
        }
      }
    },
    undefined,
    function (error) {
      console.warn("An error happened");
    }
  );

  onScreenElmoGroup = new THREE.Group();
  scene.add(onScreenElmoGroup);
}

export function animationElmoUpdates() {
  let delta = clock.getDelta();
  if (mixer) mixer.update(delta);
}

export function playElmoAction(nextAnim: string) {
  if (nextAnim == "laughAction") {
    executeCrossFade(currentAction, laughAction, 0.5);
  } else if (nextAnim == "roarAction") {
    executeCrossFade(currentAction, roarAction, 0.5);
  }
}

function setWeight(action: THREE.AnimationAction, weight: any) {
  action.enabled = true;
  action.setEffectiveTimeScale(1);
  action.setEffectiveWeight(weight);
}

function executeCrossFade(startAction: any, endAction: any, duration: any) {
  // Not only the start action, but also the end action must get a weight of 1 before fading
  // (concerning the start action this is already guaranteed in this place)
  currentAction = endAction;
  if (endAction) {
    setWeight(endAction, 1);
    endAction.time = 0;
    if (startAction) {
      // Crossfade with warping
      startAction.crossFadeTo(endAction, duration, true);
    } else {
      // Fade in
      endAction.fadeIn(duration);
    }
  } else {
    // Fade out
    startAction.fadeOut(duration);
  }
}

export function stopAllAnimations() {
  laughAction.stop();
  roarAction.stop();
  idleAction.stop();
  danceLoopAction.stop();
}

export function elmoSwitchToFaceFilter() {
  //reposition elmo
  onScreenElmoGroup.add(elmo);
  elmo.scale.set(0.15, 0.15, 0.15);
  elmo.position.set(-0.018, -0.062, -0.12);

  //elmo animations
  stopAllAnimations();
  idleAction.play();
}

export function elmoSwitchToDanceFilter() {
  //reposition elmo
  faceTrackerGroup.add(elmo);
  // elmo.scale.set(22,22,22)
  // elmo.position.set(2.5,-4.9,-4)
  elmo.scale.set(6.3, 6.3, 6.3);
  elmo.position.set(1, -1.68, 0.02);

  //elmo animations
  resetDanceLoop();
}

export function resetDanceLoop() {
  stopAllAnimations();
  currentAction = danceLoopAction;
  laughAction.play();
  roarAction.play();
  danceLoopAction.play();

  setWeight(danceLoopAction, 1);
  setWeight(laughAction, 0);
  setWeight(roarAction, 0);
}
